import React from 'react';
import { Link } from 'react-router-dom';
import { FiLock } from 'react-icons/fi';
import FooterImg from '../../src/img/footer/footer.png';

const Footer = () => {
  return (
    <footer className="bg-black text-white py-10">
      <div className="container mx-auto flex flex-col md:flex-row justify-between items-start md:items-center">
        {/* Hours Section */}
        <div className="mb-8 md:mb-0 md:flex-1">
          <h3 className="text-lg font-bold mb-2">Hours</h3>
          <p>Mon / Closed</p>
          <p>Tue - Thu / 10:00 - 8:00pm</p>
          <p>Fri / 10:00 - 12:00pm</p>
          <p>Sat / 10:00 - Midnight</p>
          <p>Sun / Closed</p>
        </div>

        {/* Pages Section */}
        <div className="mb-8 md:mb-0 md:flex-1">
          <h3 className="text-lg font-bold mb-2">Pages</h3>
          <a href="#about" className="block mb-1 hover:underline">About Us</a>
          <a href="/gallery" className="block mb-1 hover:underline">Gallery</a>
          <a href="#artist" className="block mb-1 hover:underline">Artist</a>
          <a href="#contact" className="block mb-1 hover:underline">Contact Me</a>
          
          {/* Admin Link */}
          <Link 
            to="/admin" 
            className="flex items-center gap-2 mt-3 text-gray-400 hover:text-white transition-colors group"
          >
            <FiLock className="text-sm group-hover:scale-110 transition-transform" />
            <span className="text-sm">Admin</span>
          </Link>
        </div>

        {/* Image Section */}
        <div className="md:flex-1 mt-8 md:mt-0 text-center">
          <img src={FooterImg} alt="Decorative Tattoo" className="w-32 mx-auto md:w-full" />
        </div>
      </div>

      {/* Bottom Section */}
      <div className="text-center mt-10 text-sm">
        <p>&copy; 2024 <a href="https://www.stirlingsmith.com" className="hover:underline">www.stirlingsmith.com</a>. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;